const apiUrl = (process.env.NODE_ENV === 'production')
? "https://sandbox.api.salonacme.com/manager/"
: "https://sandbox.api.salonacme.com/manager/";

module.exports = apiUrl;